import React from 'react';
import { Text } from "../..";
export var InputError = function (_a) {
    var min = _a.min, max = _a.max, leftInputValue = _a.leftInputValue, rightInputValue = _a.rightInputValue;
    var rightError = typeof leftInputValue === 'number' &&
        "Right value must be greater than " + (leftInputValue > min ? leftInputValue : min) + " and less than " + max + ".";
    var leftError = typeof rightInputValue === 'number' &&
        "Left value must be greater than " + min + " and less than " + (rightInputValue < max && rightInputValue > min ? rightInputValue : max);
    return (React.createElement(Text, { as: "p", lss: { textScale: 'caption', color: 'danger500', my: 'xs' } }, rightError || leftError));
};
//# sourceMappingURL=InputError.js.map